import React from 'react';

import styled from 'styled-components';

import media from '../../../theme/media';
import { Icon } from '../../common/Icon/Icon';
import { Row } from '../../common/Layout/Row';
import NewInputWrapper from '../../form-multi/NewInputWrapper';

export const SearchIconWrap = styled.div`
    margin-right: 16px;

    ${media.desktop1920} {
        margin-right: 24px;
    }
`;

const focus = (e) => {
    if (e.currentTarget) {
        const input = e.currentTarget.firstElementChild;
        input.focus();
    } else {
        console.log('Focus method not support');
    }
};

export const InputSearch = (props) => {
    return (
        <Row indent="32px" onClick={(e) => props.toggle(e, true)}>
            <NewInputWrapper
                name="search"
                setFocus={focus}
                leftInputComponent={
                    <SearchIconWrap>
                        <Icon name="search" color="mediumGray" />
                    </SearchIconWrap>
                }
            >
                <input type="search" placeholder={props.placeholder} autoFocus={props.autoFocus} />
            </NewInputWrapper>
        </Row>
    );
};
